import { compact, map } from "lodash";

type ArrayIterator<T, TResult> = (
  value: T,
  index: number,
  collection: T[]
) => TResult;

export function mapCompact<T, TResult>(
  collection:
    | ArrayLike<T | null | undefined | false | "" | 0>
    | null
    | undefined,
  iteratee: ArrayIterator<T, NonNullable<TResult>>
): Array<NonNullable<TResult>> {
  return map(compact(collection), iteratee);
}
